import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('div', {
    staticClass: "card card-custom gutter-b"
  }, [_c('div', {
    staticClass: "card-header card-header-tabs-line"
  }, [_c('ul', {
    ref: "builder-tab",
    staticClass: "nav nav-dark nav-bold nav-tabs nav-tabs-line",
    attrs: {
      "role": "tablist"
    }
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "data-tab": "0",
      "data-toggle": "tab",
      "href": "#",
      "role": "tab"
    },
    on: {
      "click": _vm.setActiveTab
    }
  }, [_vm._v(" Cadastro ")])])])]), _c('b-form', {
    staticClass: "form",
    on: {
      "submit": function submit($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('b-tabs', {
    staticClass: "hide-tabs",
    model: {
      value: _vm.tabIndex,
      callback: function callback($$v) {
        _vm.tabIndex = $$v;
      },
      expression: "tabIndex"
    }
  }, [_c('b-tab', {
    attrs: {
      "active": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Escolha o tipo da conta",
      "label-for": "tipo"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.tipo,
      expression: "form.tipo"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "tipo",
      "id": "tipo"
    },
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.form, "tipo", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, _vm._l(_vm.tipos, function (t, index) {
    return _c('option', {
      key: 'code' + index,
      domProps: {
        "value": t.type
      }
    }, [_vm._v(" " + _vm._s(t.description) + " ")]);
  }), 0)])], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "nome",
      "label-for": "nome",
      "label": "Nome"
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "20",
      "state": _vm.validateState('nome')
    },
    model: {
      value: _vm.$v.form.nome.$model,
      callback: function callback($$v) {
        _vm.$set(_vm.$v.form.nome, "$model", $$v);
      },
      expression: "$v.form.nome.$model"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Escolha o banco",
      "label-for": "banco"
    }
  }, [_c('VueSelect', {
    ref: "banco",
    class: {
      hasErrorsAcvtivity: !_vm.bancoFilled,
      inputFilledBanco: _vm.bancoFilled
    },
    attrs: {
      "id": "banco",
      "filterable": false,
      "options": _vm.bancos,
      "placeholder": "Informe o código ou nome do banco"
    },
    on: {
      "input": _vm.setBanco,
      "search": _vm.onSearchBancos
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.name) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.name) + " ")])];
      }
    }]),
    model: {
      value: _vm.bancoSelected,
      callback: function callback($$v) {
        _vm.bancoSelected = $$v;
      },
      expression: "bancoSelected"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o código ou nome do banco ")])], 2)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "agencia",
      "label-for": "agencia",
      "label": "Agência"
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "4",
      "state": _vm.validateState('agencia')
    },
    model: {
      value: _vm.$v.form.agencia.$model,
      callback: function callback($$v) {
        _vm.$set(_vm.$v.form.agencia, "$model", $$v);
      },
      expression: "$v.form.agencia.$model"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "conta",
      "label-for": "conta",
      "label": "Conta"
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "10",
      "state": _vm.validateState('conta')
    },
    model: {
      value: _vm.$v.form.conta.$model,
      callback: function callback($$v) {
        _vm.$set(_vm.$v.form.conta, "$model", $$v);
      },
      expression: "$v.form.conta.$model"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "beneficiario",
      "label-for": "beneficiario",
      "label": "Nome do Benificiário"
    }
  }, [_c('b-form-input', {
    attrs: {
      "state": _vm.validateState('beneficiario')
    },
    model: {
      value: _vm.$v.form.beneficiario.$model,
      callback: function callback($$v) {
        _vm.$set(_vm.$v.form.beneficiario, "$model", $$v);
      },
      expression: "$v.form.beneficiario.$model"
    }
  })], 1)], 1), _vm.mostrarCampoSaldo ? _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "saldo",
      "label-for": "prsaldoeco",
      "label": "Saldo inicial"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "data-testid": "saldo-inicial-banco"
    },
    model: {
      value: _vm.form.saldo,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "saldo", $$v);
      },
      expression: "form.saldo"
    }
  }, 'money', _vm.configMoney, false))], 1)], 1) : _vm._e()], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    staticClass: "mb-2",
    attrs: {
      "label": "Tipo da chave",
      "label-for": "tipo_chave_pix_carne"
    }
  }, [_c('b-form-select', {
    attrs: {
      "id": "tipo_chave_pix_carne",
      "value": _vm.form.tipo_chave_pix_carne,
      "options": _vm.tiposChavePixCarne
    },
    on: {
      "change": _vm.onPixKeyTypeChange
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    staticClass: "mb-2",
    attrs: {
      "label": "Chave PIX para o Carnê Loja",
      "label-for": "chave_pix_carne"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "chave_pix_carne",
      "value": _vm.form.chave_pix_carne,
      "type": _vm.pixKeyInputType,
      "placeholder": _vm.pixKeyPlaceholder,
      "maxlength": _vm.pixKeyMaxLength,
      "autocomplete": "off"
    },
    on: {
      "input": _vm.onPixKeyInput
    }
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "id": "pix_carne_padrao",
      "switch": "",
      "size": "md"
    },
    model: {
      value: _vm.form.pix_carne_padrao,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "pix_carne_padrao", $$v);
      },
      expression: "form.pix_carne_padrao"
    }
  }, [_vm._v(" Utilizar esta conta para gerar o QR-Code ")])], 1)], 1), _vm.mostrarSecaoSicoob ? _c('b-row', {
    staticClass: "mt-4"
  }, [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('div', {
    staticClass: "card border border-primary sicoob-section"
  }, [_c('div', {
    staticClass: "card-header d-flex align-items-center justify-content-between",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function click($event) {
        _vm.sicoobCollapsed = !_vm.sicoobCollapsed;
      }
    }
  }, [_c('h5', {
    staticClass: "mb-0 font-weight-bolder text-primary"
  }, [_vm._v(" Integração Sicoob API ")]), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_vm.form.integracao_api ? _c('b-badge', {
    staticClass: "mr-3",
    attrs: {
      "variant": "danger"
    }
  }, [_vm._v(" Produção ")]) : _vm._e(), _c('b-icon', {
    attrs: {
      "icon": _vm.sicoobCollapsed ? 'chevron-down' : 'chevron-up'
    }
  })], 1)]), _c('b-collapse', {
    attrs: {
      "visible": !_vm.sicoobCollapsed
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('b-alert', {
    staticClass: "d-flex align-items-center",
    attrs: {
      "show": "",
      "variant": _vm.certificadoDisponivel ? 'success' : 'warning'
    }
  }, [_c('b-icon', {
    staticClass: "mr-2",
    attrs: {
      "icon": _vm.certificadoDisponivel ? 'shield-check' : 'shield-exclamation',
      "font-scale": "1.4"
    }
  }), _c('div', [_c('strong', [_vm._v("Certificado digital da empresa:")]), _c('b-badge', {
    staticClass: "ml-2",
    attrs: {
      "variant": _vm.certificadoDisponivel ? 'success' : 'danger'
    }
  }, [_vm._v(" " + _vm._s(_vm.certificadoDisponivel ? "Encontrado" : "Não encontrado") + " ")]), !_vm.certificadoDisponivel ? _c('div', {
    staticClass: "mt-1",
    staticStyle: {
      "font-size": "0.85rem"
    }
  }, [_vm._v(" Para usar a API Sicoob, cadastre primeiro o certificado digital no emitente da empresa. ")]) : _vm._e()], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Usar integração por API",
      "label-for": "integracao_api"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "id": "integracao_api",
      "switch": "",
      "size": "lg"
    },
    model: {
      value: _vm.form.integracao_api,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "integracao_api", $$v);
      },
      expression: "form.integracao_api"
    }
  }, [_vm._v(" " + _vm._s(_vm.form.integracao_api ? "Ativada" : "Desativada") + " ")])], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Client ID Sicoob",
      "label-for": "client_id"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "client_id",
      "disabled": !_vm.form.integracao_api,
      "autocomplete": "off"
    },
    model: {
      value: _vm.form.client_id,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "client_id", $$v);
      },
      expression: "form.client_id"
    }
  }), _c('small', {
    staticClass: "text-muted d-block mt-1"
  }, [_vm._v(" Confirme o Client ID Sicoob e o Número do cliente com a gerência da sua conta Sicoob. ")])], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Número do cliente Sicoob",
      "label-for": "numero_contrato"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "numero_contrato",
      "disabled": !_vm.form.integracao_api,
      "autocomplete": "off"
    },
    model: {
      value: _vm.form.numero_contrato,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "numero_contrato", $$v);
      },
      expression: "form.numero_contrato"
    }
  }), _c('small', {
    staticClass: "text-muted d-block mt-1"
  }, [_vm._v(" Também pode ser chamado de número do contrato/cliente na documentação Sicoob. ")])], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Chave Pix",
      "label-for": "chave_pix"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "chave_pix",
      "disabled": !_vm.form.integracao_api,
      "autocomplete": "off"
    },
    model: {
      value: _vm.form.chave_pix,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "chave_pix", $$v);
      },
      expression: "form.chave_pix"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Conta Corrente",
      "label-for": "conta_sicoob"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "conta_sicoob",
      "disabled": !_vm.form.integracao_api,
      "autocomplete": "off"
    },
    model: {
      value: _vm.form.conta,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "conta", $$v);
      },
      expression: "form.conta"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Agência / Cooperativa",
      "label-for": "agencia_sicoob"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "agencia_sicoob",
      "disabled": !_vm.form.integracao_api,
      "autocomplete": "off"
    },
    model: {
      value: _vm.form.agencia,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "agencia", $$v);
      },
      expression: "form.agencia"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Status da API",
      "label-for": "status_api"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "status_api",
      "value": _vm.form.status_api || 'Não informado',
      "disabled": ""
    }
  })], 1)], 1)], 1), _c('hr', {
    staticClass: "my-4"
  }), _c('h6', {
    staticClass: "font-weight-bolder text-primary mb-3"
  }, [_vm._v(" Configurações de cobrança ")]), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Tipo de multa",
      "label-for": "tipo_multa"
    }
  }, [_c('b-form-select', {
    attrs: {
      "id": "tipo_multa"
    },
    model: {
      value: _vm.form.tipo_multa,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "tipo_multa", $$v);
      },
      expression: "form.tipo_multa"
    }
  }, [_c('b-form-select-option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v(" 0 - Isento ")]), _c('b-form-select-option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v(" 1 - Valor fixo ")]), _c('b-form-select-option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v(" 2 - Percentual ")])], 1)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Dias para multa",
      "label-for": "dias_multa"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "dias_multa",
      "disabled": _vm.multaIsenta,
      "type": "number",
      "min": "0"
    },
    model: {
      value: _vm.form.dias_multa,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "dias_multa", _vm._n($$v));
      },
      expression: "form.dias_multa"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": _vm.multaValorLabel,
      "label-for": "valor_multa"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "id": "valor_multa",
      "disabled": _vm.multaIsenta
    },
    model: {
      value: _vm.form.valor_multa,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "valor_multa", $$v);
      },
      expression: "form.valor_multa"
    }
  }, 'money', _vm.configMoney, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Tipo de juros",
      "label-for": "tipo_juros_mora"
    }
  }, [_c('b-form-select', {
    attrs: {
      "id": "tipo_juros_mora"
    },
    model: {
      value: _vm.form.tipo_juros_mora,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "tipo_juros_mora", $$v);
      },
      expression: "form.tipo_juros_mora"
    }
  }, [_c('b-form-select-option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v(" 1 - Valor por dia ")]), _c('b-form-select-option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v(" 2 - Taxa mensal ")]), _c('b-form-select-option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v(" 3 - Isento ")])], 1)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Dias para juros",
      "label-for": "dias_juros_mora"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "dias_juros_mora",
      "disabled": _vm.jurosIsento,
      "type": "number",
      "min": "0"
    },
    model: {
      value: _vm.form.dias_juros_mora,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "dias_juros_mora", _vm._n($$v));
      },
      expression: "form.dias_juros_mora"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": _vm.jurosValorLabel,
      "label-for": "valor_juros_mora"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "id": "valor_juros_mora",
      "disabled": _vm.jurosIsento
    },
    model: {
      value: _vm.form.valor_juros_mora,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "valor_juros_mora", $$v);
      },
      expression: "form.valor_juros_mora"
    }
  }, 'money', _vm.configMoney, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Dias limite para pagamento",
      "label-for": "dias_limite_pagamento"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "dias_limite_pagamento",
      "type": "number",
      "min": "0"
    },
    model: {
      value: _vm.form.dias_limite_pagamento,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "dias_limite_pagamento", _vm._n($$v));
      },
      expression: "form.dias_limite_pagamento"
    }
  }), _c('small', {
    staticClass: "text-muted d-block mt-1"
  }, [_vm._v(" Quantidade de dias após o vencimento em que o boleto ainda poderá ser pago. ")])], 1)], 1)], 1), _c('hr', {
    staticClass: "my-4"
  }), _c('h6', {
    staticClass: "font-weight-bolder text-primary mb-3"
  }, [_vm._v(" Mensagens de instrução do boleto ")]), _c('small', {
    staticClass: "text-muted d-block mb-3"
  }, [_vm._v(" O Sicoob permite até 5 mensagens, com no máximo 40 caracteres cada. ")]), _c('b-row', _vm._l(5, function (index) {
    return _c('b-col', {
      key: "mensagem_instrucao_".concat(index),
      attrs: {
        "md": "6"
      }
    }, [_c('b-form-group', {
      attrs: {
        "label": "Mensagem ".concat(index),
        "label-for": "mensagem_instrucao_".concat(index)
      }
    }, [_c('b-form-input', {
      attrs: {
        "id": "mensagem_instrucao_".concat(index),
        "maxlength": "40",
        "autocomplete": "off"
      },
      model: {
        value: _vm.form["mensagem_instrucao_".concat(index)],
        callback: function callback($$v) {
          _vm.$set(_vm.form, "mensagem_instrucao_".concat(index), $$v);
        },
        expression: "form[`mensagem_instrucao_${index}`]"
      }
    }), _c('small', {
      staticClass: "text-muted d-block text-right"
    }, [_vm._v(" " + _vm._s(_vm.mensagemLength(index)) + "/40 ")])], 1)], 1);
  }), 1), _c('div', {
    staticClass: "d-flex justify-content-end"
  }, [_c('button', {
    ref: "testar_conexao_sicoob",
    staticClass: "btn btn-outline-primary font-weight-bold",
    attrs: {
      "type": "button",
      "disabled": !_vm.form.integracao_api || !_vm.form.id_banco || _vm.testandoConexao
    },
    on: {
      "click": _vm.testarConexaoSicoob
    }
  }, [_vm.testandoConexao ? _c('b-spinner', {
    attrs: {
      "small": ""
    }
  }) : _c('span', [_vm._v("Testar conexão Sicoob")])], 1)]), !_vm.form.id_banco ? _c('small', {
    staticClass: "text-muted d-block text-right mt-1"
  }, [_vm._v(" Salve a conta bancária para liberar o teste de conexão. ")]) : _vm._e()], 1)])], 1)])], 1) : _vm._e(), _vm.mostrarSecaoSicredi ? _c('b-row', {
    staticClass: "mt-4"
  }, [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('div', {
    staticClass: "card border border-success sicredi-section"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('b-alert', {
    attrs: {
      "show": "",
      "variant": "info"
    }
  }, [_vm._v(" Utilize as credenciais de produção fornecidas pelo Sicredi. Confirme cooperativa, posto e código do beneficiário com a sua agência/cooperativa. ")]), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Usar integração por API",
      "label-for": "integracao_api_sicredi"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "id": "integracao_api_sicredi",
      "switch": "",
      "size": "lg"
    },
    model: {
      value: _vm.form.integracao_api,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "integracao_api", $$v);
      },
      expression: "form.integracao_api"
    }
  }, [_vm._v(" " + _vm._s(_vm.form.integracao_api ? "Ativada" : "Desativada") + " ")])], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Ambiente",
      "label-for": "ambiente_api_sicredi"
    }
  }, [_c('b-form-select', {
    attrs: {
      "id": "ambiente_api_sicredi",
      "disabled": ""
    },
    model: {
      value: _vm.form.ambiente_api,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "ambiente_api", $$v);
      },
      expression: "form.ambiente_api"
    }
  }, [_c('b-form-select-option', {
    attrs: {
      "value": "producao"
    }
  }, [_vm._v(" Produção ")])], 1)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Status da API"
    }
  }, [_c('b-form-input', {
    attrs: {
      "value": _vm.form.status_api || 'Não testada',
      "disabled": ""
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "x-api-key",
      "label-for": "sicredi_x_api_key"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "sicredi_x_api_key",
      "disabled": !_vm.form.integracao_api,
      "type": "password",
      "maxlength": "36",
      "autocomplete": "new-password",
      "placeholder": _vm.sicrediPossuiXApiKey ? 'Chave cadastrada — digite para substituir' : 'Informe a x-api-key de 36 caracteres'
    },
    model: {
      value: _vm.form.config.sicredi.x_api_key,
      callback: function callback($$v) {
        _vm.$set(_vm.form.config.sicredi, "x_api_key", $$v);
      },
      expression: "form.config.sicredi.x_api_key"
    }
  }), _c('small', {
    class: _vm.sicrediPossuiXApiKey ? 'text-success' : 'text-muted'
  }, [_vm._v(" " + _vm._s(_vm.sicrediPossuiXApiKey ? "Existe uma chave cadastrada. Preencha somente para alterá-la." : "Chave de produção de 36 caracteres liberada no Portal do Desenvolvedor Sicredi.") + " ")])], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Username",
      "label-for": "sicredi_username"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "sicredi_username",
      "disabled": !_vm.form.integracao_api,
      "maxlength": "9",
      "autocomplete": "off"
    },
    model: {
      value: _vm.form.config.sicredi.username,
      callback: function callback($$v) {
        _vm.$set(_vm.form.config.sicredi, "username", $$v);
      },
      expression: "form.config.sicredi.username"
    }
  }), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v(" Código do beneficiário (5) + cooperativa (4). ")])], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Código de acesso / Password",
      "label-for": "sicredi_password"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "sicredi_password",
      "disabled": !_vm.form.integracao_api,
      "type": "password",
      "maxlength": "64",
      "autocomplete": "new-password",
      "placeholder": _vm.sicrediPossuiPassword ? 'Senha cadastrada — digite para substituir' : 'Informe o código de acesso'
    },
    model: {
      value: _vm.form.config.sicredi.password,
      callback: function callback($$v) {
        _vm.$set(_vm.form.config.sicredi, "password", $$v);
      },
      expression: "form.config.sicredi.password"
    }
  }), _vm.sicrediPossuiPassword ? _c('small', {
    staticClass: "text-success"
  }, [_vm._v(" Existe uma senha cadastrada. Preencha somente para alterá-la. ")]) : _vm._e()], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Cooperativa",
      "label-for": "sicredi_cooperativa"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "sicredi_cooperativa",
      "disabled": !_vm.form.integracao_api,
      "maxlength": "4"
    },
    model: {
      value: _vm.form.agencia,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "agencia", $$v);
      },
      expression: "form.agencia"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Posto (confirme com a agência)",
      "label-for": "sicredi_posto"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "sicredi_posto",
      "disabled": !_vm.form.integracao_api,
      "maxlength": "2"
    },
    model: {
      value: _vm.form.posto_beneficiario,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "posto_beneficiario", $$v);
      },
      expression: "form.posto_beneficiario"
    }
  }), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v(" Confirme o código do posto com a sua agência ou cooperativa Sicredi. ")])], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Código do beneficiário",
      "label-for": "sicredi_codigo_beneficiario"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "sicredi_codigo_beneficiario",
      "disabled": !_vm.form.integracao_api,
      "maxlength": "5"
    },
    model: {
      value: _vm.form.codigo_convenio,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "codigo_convenio", $$v);
      },
      expression: "form.codigo_convenio"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Tipo de cobrança",
      "label-for": "sicredi_tipo_cobranca"
    }
  }, [_c('b-form-select', {
    attrs: {
      "id": "sicredi_tipo_cobranca",
      "disabled": !_vm.form.integracao_api,
      "options": _vm.tiposCobrancaSicredi
    },
    model: {
      value: _vm.form.config.sicredi.tipo_cobranca,
      callback: function callback($$v) {
        _vm.$set(_vm.form.config.sicredi, "tipo_cobranca", $$v);
      },
      expression: "form.config.sicredi.tipo_cobranca"
    }
  }), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v(" Use boleto híbrido somente quando o contrato Sicredi estiver habilitado para QR Code Pix. ")])], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Espécie do documento",
      "label-for": "sicredi_especie_documento"
    }
  }, [_c('b-form-select', {
    attrs: {
      "id": "sicredi_especie_documento",
      "disabled": !_vm.form.integracao_api,
      "options": _vm.especiesDocumentoSicredi
    },
    model: {
      value: _vm.form.config.sicredi.especie_documento,
      callback: function callback($$v) {
        _vm.$set(_vm.form.config.sicredi, "especie_documento", $$v);
      },
      expression: "form.config.sicredi.especie_documento"
    }
  })], 1)], 1)], 1), _c('div', {
    staticClass: "d-flex justify-content-end"
  }, [_c('button', {
    staticClass: "btn btn-outline-success font-weight-bold",
    attrs: {
      "type": "button",
      "disabled": !_vm.form.integracao_api || !_vm.form.id_banco || _vm.testandoConexaoSicredi
    },
    on: {
      "click": _vm.testarConexaoSicredi
    }
  }, [_vm.testandoConexaoSicredi ? _c('b-spinner', {
    attrs: {
      "small": ""
    }
  }) : _c('span', [_vm._v("Testar conexão Sicredi")])], 1)]), !_vm.form.id_banco ? _c('small', {
    staticClass: "text-muted d-block text-right mt-1"
  }, [_vm._v(" Salve a conta bancária para liberar o teste de conexão. ")]) : _vm._e()], 1)])])], 1) : _vm._e()], 1)], 1)], 1), _c('div', {
    staticClass: "card-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('button', {
    ref: "submit_novo_banco",
    staticClass: "btn btn-primary font-weight-bold",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(" Salvar ")]), _c('router-link', {
    staticClass: "btn btn-clean font-weight-bold",
    attrs: {
      "to": {
        name: 'bancosLista'
      }
    }
  }, [_vm._v(" Cancelar ")])], 1)])])])], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };